export const PROPERTY_ROBBERY = {
    title: '中国大地财产保险股份有限公司',
    subtitle: '家庭财产保险<br>附加盗窃、抢劫保险（B）条款',
    register_number: '（注册号：C00001032122018073010752）',
    protocols: [
        {
            intro: '保险标的',
            list: [
                {
                    order: '第一条',
                    context: '被保险人所有的、坐落于或存放在保险单载明地址的房屋内的下列财产，可以作为本附加险的保险标的：',
                    details: [
                        { text: '（一）室内装潢；' },
                        { text: '（二）家用电器，包括：', regulations: [
                            '1．普通家用电器（含安装在房屋外的空调器和太阳能热水器等家用电器的室外设备）；',
                            '2．便携式家用电器：包括笔记本电脑、移动电话、数码播放器、电动剃须刀、照相机、摄像机；'
                        ] },
                        { text: '（三）文体娱乐用品，包括文具、书籍、球具、棋牌；' },
                        { text: '（四）衣物、床上用品、鞋帽、箱包；' },
                        { text: '（五）家具及其他生活用具；' },
                        { text: '（六）经保险人同意承保的其他家庭财产。' }
                    ]
                }
            ]
        },
        {
            intro: '保险责任',
            list: [
                { order: '第二条', context: '在保险期间内，被保险人存放于主险保险单载明地址的房屋内的保险标的由于遭受经公安部门确认的外部人员入室盗窃、抢劫（以下简称“盗抢”）行为而造成的直接经济损失，自公安部门认定的案发之日起六十日内，被盗抢的保险标的仍未查获或仍未从盗抢人处获得赔偿的，保险人按本附加险合同的约定负责赔偿。 ' },
                { order: '第三条', context: '在保险期间内，保险标的在被盗窃、抢劫过程中受到损坏需要修复的，对被保险人支付的必要的、合理的费用，保险人按照本附加险合同的约定也负责赔偿。' }
            ]
        },
        {
            intro: '责任免除',
            list: [
                {
                    order: '第四条',
                    context: '下列原因造成的损失和费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）窗外钩物行为或无明显作案痕迹的盗窃行为；' },
                        { text: '（二）门窗未锁遭受盗抢；' },
                        { text: '（三）被保险人的家庭成员、家政服务人员、暂居人员盗抢或纵容他人盗抢。' }
                    ]
                },
                {
                    order: '第五条',
                    context: '下列损失和费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）保险标的在存放处所无人居住或无人看管超过六十天的情况下遭受的盗窃损失；' },
                        { text: '（二）保险标的在保险单载明地址的房屋外遭受的盗抢损失，但安装在房屋外的空调器和太阳能热水器等家用电器的室外设备除外；' },
                        { text: '（三）保险单载明的免赔额或按照保险单载明的免赔率计算的免赔额；' },
                        { text: '（四）其他不属于本保险责任范围内的损失和费用。' }
                    ]
                }
            ]
        },
        {
            intro: '保险金额和免赔额（率）',
            list: [
                { order: '第六条', context: '保险金额由投保人与保险人协商确定，并在保险单中载明。' },
                { order: '第七条', context: '每次事故免赔额（率）由投保人与保险人在签订本附加险合同时协商确定，并在保险单中载明。' }
            ]
        },
        {
            intro: '赔偿处理',
            list: [
                { order: '第八条', context: '保险标的发生保险责任范围内的损失时，保险人按照其实际损失在扣除每次事故免赔额或按照保险单载明的每次事故免赔率计算的免赔额后进行赔偿。' },
                { order: '第九条', context: '在保险期间内，保险人在本附加险合同下承担的赔偿金额累计不超过保险单载明的保险金额。' }
            ]
        },
        {
            intro: '其他事项',
            list: [
                { order: '第十条', context: '本附加险条款未尽事宜，以主险条款的约定为准；本附加险条款与主险条款若有相抵触之处，以本附加险条款的约定为准。' }
            ]
        }
    ]
}